import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { Upsell1Page } from './pages/Upsell1Page';
import { Upsell2Page } from './pages/Upsell2Page';
import { ThankYouPage } from './pages/ThankYouPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/upsell-1" element={<Upsell1Page data-id="element-5" />} data-id="element-4" />
        <Route path="/upsell-2" element={<Upsell2Page data-id="element-7" />} data-id="element-6" />
        <Route path="/thank-you" element={<ThankYouPage data-id="element-9" />} data-id="element-8" />
      </Routes>
    </BrowserRouter>;
}